import { createContext, useContext } from "react"

interface StepperContext {
  goToNextStep: () => void
  activeStep: number
  isLastStep: boolean
}

const contextDefaultValue: StepperContext = {
  goToNextStep: () => {},
  isLastStep: false,
  activeStep: 0,
}

export const stepperContext = createContext(contextDefaultValue)

export const useStepperContext = () => useContext(stepperContext)
